import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'mega-store-factory-serial-number-input',
  templateUrl: './serial-number-input.component.html',
  styleUrls: ['./serial-number-input.component.scss']
})
export class SerialNumberInputComponent {
  serialNumberForm: FormGroup;
  serialNumbers: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<SerialNumberInputComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.serialNumberForm = new FormGroup({
      serialNumber: new FormControl('', [Validators.required, Validators.minLength(1)])
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (this.serialNumbers.length > 0) {
      this.dialogRef.close({
        serialNumbers: this.serialNumbers
      });
    }
  }

  onSerialNumberChange(event: any): void {
    // This can handle both manual input and barcode scanner input
    const value = event.target.value;
    this.serialNumberForm.patchValue({
      serialNumber: value
    });
  }

  remove(serialNumber: string): void {
    const index = this.serialNumbers.indexOf(serialNumber);

    if (index >= 0) {
      this.serialNumbers.splice(index, 1);
    }
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault();
      const value = this.serialNumberForm.get('serialNumber')?.value?.trim();
      if (value && !this.serialNumbers.includes(value)) {
        this.serialNumbers.push(value);
        this.serialNumberForm.get('serialNumber')?.setValue('');
      }
    }
  }

  isFormValid(): boolean {
    return this.serialNumbers.length > 0;
  }
} 